var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"disable-right-click",rawName:"v-disable-right-click"}],attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('router-view')],1),_c('router-view',{attrs:{"name":"footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }